import { useAppSelector } from '@customer/store/hooks';
import { MapProviderModel, MapProviderType } from '@customer/store/apis/authApi';

// No map provider should ever need to zoom more than this.
export const MAX_NATIVE_ZOOM = 21;
export const MIN_ZOOM = 1;

// Open Street Map default max native zoom.
const OSM_MAX_NATIVE_ZOOM = 19;

interface MapConfig extends MapProviderModel {
  maxNativeZoom: number;
  maxZoom: number;
}

const getSafeZoom = (zoom: number | undefined, fallback: number): number => {
  if (typeof zoom !== 'undefined') {
    return Math.round(Math.max(Math.min(zoom, MAX_NATIVE_ZOOM), MIN_ZOOM));
  }
  return fallback;
};

export const useMapConfig = (): MapConfig => {
  const mapConfig: MapProviderModel | undefined = useAppSelector(
    state => state.auth.currentSite?.map,
  );

  const { maxZoom, maxNativeZoom, uri, layerName, providerType } = mapConfig ?? {};

  const safeMaxNativeZoom = getSafeZoom(maxNativeZoom, OSM_MAX_NATIVE_ZOOM);

  const safeMaxZoom = getSafeZoom(maxZoom, safeMaxNativeZoom);

  return {
    providerType: providerType ?? MapProviderType.OpenStreetMap,
    maxNativeZoom: safeMaxNativeZoom,
    maxZoom: safeMaxZoom,
    uri,
    layerName,
  };
};

export default useMapConfig;
